import {
  useEffectWithController,
  usePromise
} from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserContext, {
  useGetUser,
  useIsLoggedIn
} from '~/context/common/UserContext';
import SavedSearchesContext from '~/context/home/SavedSearchesContext';
import { readSavedSearch } from '~/services/home/SavedSearchService';
import generateErrorLogger from '~/utilities/errorHandlers';

export default function useGetSavedSearches() {
  const { setSavedSearches } = useContext(SavedSearchesContext);
  const mounted = usePromise();
  const {
    userState: { isLoaded }
  } = useContext(UserContext);
  const { email } = useGetUser();
  const isLoggedIn = useIsLoggedIn();

  useEffectWithController(
    controller => {
      if (!email || !isLoaded || !isLoggedIn) return;

      mounted(readSavedSearch(email, controller))
        .then(({ data }) => {
          setSavedSearches(data.savedSearches ?? []);
        })
        .catch(
          generateErrorLogger(
            'Get saved searches',
            {},
            { callback: () => setSavedSearches([]) }
          )
        );
    },
    [email, isLoaded, isLoggedIn, mounted, setSavedSearches]
  );
}
